// PRE_SURVEY — Section 10.

import { useState } from 'react';
import AffectSurvey from '../components/AffectSurvey';
import StopButton from '../components/StopButton';
import ConfirmationModal from '../components/ConfirmationModal';
import { useSessionStore } from '../store/sessionStore';
import { useParticipantStore } from '../store/participantStore';

export default function PreSurveyScreen({ onContinue, onAbandon }) {
  const [valence, setValence] = useState(3);
  const [arousal, setArousal] = useState(3);
  const [confirmingStop, setConfirmingStop] = useState(false);
  const setAffectPre = useSessionStore((s) => s.setAffectPre);
  const abandon = useSessionStore((s) => s.abandon);
  const participantPatch = useParticipantStore((s) => s.patch);

  function handleContinue() {
    setAffectPre(valence, arousal);
    onContinue();
  }

  async function handleStop() {
    abandon('pre_survey');
    await participantPatch({ active_in_session: false, current_session_id: null });
    onAbandon();
  }

  return (
    <div className="screen">
      <h1 className="font-display text-2xl mb-6">Pre-Session Check-in</h1>
      <AffectSurvey valence={valence} arousal={arousal} onValenceChange={setValence} onArousalChange={setArousal} />

      <div className="mt-auto pt-6">
        <button type="button" onClick={handleContinue} className="btn-primary">
          Continue
        </button>
        <StopButton onClick={() => setConfirmingStop(true)} />
      </div>

      <ConfirmationModal
        open={confirmingStop}
        title="Stop this session?"
        message="Nothing will be saved from this session."
        confirmLabel="Yes, stop"
        cancelLabel="No, keep going"
        danger
        onCancel={() => setConfirmingStop(false)}
        onConfirm={handleStop}
      />
    </div>
  );
}
